import React from 'react'
import { GallerySectionProps } from './GallerySection.types'
import styles from './GallerySection.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { IMAGE_EDITOR_STORE } from 'store'
import { getImageIndications } from 'components/shared/ImageEditable/ImageEditable.utils'
import { Picture } from '@touche-lts/panel-ui/dist'

const GallerySectionComponent = (props: GallerySectionProps) => {
  const {
    className,
    style,
    [IMAGE_EDITOR_STORE]: {
      images,
      indexOnFocus,
      onIndexOnFocusChange,
      onRemoveCroppingClick
    }
  } = props

  return (
    <div
      className={cl(styles.container, styles.scrollable, className)}
      style={style}
    >
      {images.map((img, index) => {
        const isImageOnFocus = index === indexOnFocus

        return (
          <Picture
            key={img.id}
            src={img.src}
            indications={getImageIndications(img)}
            className={cl(styles.galleryImage, {
              [styles.galleryImageOnFocus]: isImageOnFocus
            })}
            onClick={() => onIndexOnFocusChange(index)}
            removeCropping={onRemoveCroppingClick(index)}
          />
        )
      })}
    </div>
  )
}

const GallerySection = inject(
  'IMAGE_EDITOR_STORE'
)(observer(GallerySectionComponent))
export { GallerySection }
